import React, { FunctionComponent } from 'react';

import Box from '@mui/material/Box';

import { useGetTableEntriesByFeatureId } from '../../../../shared/hooks/use-get-table-entries-by-feature-id/use-get-table-entries-by-feature-id.hook';
import { useResetPageNumberAfterFiltering } from '../../../../shared/hooks/use-reset-page-number-after-filtering/use-reset-page-number-after-filtering.hook';
import { useSetFeatureId } from '../../../../shared/hooks/use-set-feature-id/use-set-feature-id.hook';
import { onChangeTableRowsPerPage } from '../../../../shared/utils/on-change-table-rows-per-page/on-change-table-rows-per-page.util';
import { onTablePageChange } from '../../../../shared/utils/on-table-page-change/on-table-page-change.util';
import { useAppDispatch } from '../../../../store/hooks';
import NoResults from '../../../shared/components/no-results/NoResults';
import SDCTable from '../../../shared/components/ui/Table/components/table/SDCTable';
import { getPaginationConfig } from '../../../shared/components/ui/Table/utils/get-pagination-config.util';
import {
  addPagination,
  resetPagination,
  setCampaignId,
} from '../../store/slices/campaign-reports.slice';
import { getCampaignReportsTotalCount } from '../../thunks/get-campaign-reports-total-count.thunk';
import { useGetVehicleReportsTableConfig } from './hooks/use-get-vehicle-reports-table-config/use-get-vehicle-reports-table-config.hook';
import { useGetVehicleReports } from './hooks/use-get-vehicle-reports/use-get-vehicle-reports';
import { vehicleReportsTableColumnsDef } from './utils/vehicle-reports-table-columns-def.util';

export const VehicleReports: FunctionComponent = (): JSX.Element => {
  const { tableRows, isLoading, campaignId, count, rowsPerPage, page } =
    useGetVehicleReportsTableConfig();

  const dispatch = useAppDispatch();

  useSetFeatureId(setCampaignId, parseInt(campaignId as string, 10));

  useGetTableEntriesByFeatureId(
    getCampaignReportsTotalCount,
    parseInt(campaignId as string, 10)
  );

  useGetVehicleReports(campaignId);

  useResetPageNumberAfterFiltering(count, page, rowsPerPage, resetPagination);

  return (
    <Box
      sx={{
        height: '100%',
        padding: 0,
        marginTop: '48px',
      }}
    >
      {tableRows?.length > 0 && (
        <SDCTable
          ariaLabel="campaign-reports-table"
          bulkActions={false}
          checkboxSelection={false}
          columns={vehicleReportsTableColumnsDef}
          rows={tableRows}
          stickyHeader={true}
          data-testid="sdc-table-vehicle-reports"
          paginationConfig={getPaginationConfig(
            count,
            rowsPerPage,
            page,
            onTablePageChange(dispatch, rowsPerPage, addPagination),
            onChangeTableRowsPerPage(dispatch, addPagination)
          )}
        />
      )}
      {tableRows?.length === 0 && !isLoading && <NoResults />}
    </Box>
  );
};
